import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'Release';
  id: string;
  versionNumber: string;
  platform: string | null;
  changelog: string | null;
  releaseNotes: string | null;
  createdAt: string;
  clientTestingStartedAt: string | null;
  clientApprovedAt: string | null;
  clientApprovedBy: User.BaseView | null;
  builds: Array<{
    '@id': string;
    '@type': 'Build';
    id: string;
    buildNumber: number;
    environment: string;
    platform: string | null;
    link: string;
    qaApprovedAt: string | null;
    qaApprovedBy: User.BaseView | null;
    expired: boolean;
    createdAt: string;
    createdBy: User.BaseView;
    buildEvents: Array<{
      '@id': string;
      '@type': 'BuildEvent';
      id: string;
      type: string;
      percent: number | null;
      recordedAt: string;
    }>;
  }>;
  tickets: Array<{
    '@id': string;
    '@type': 'Ticket';
    number: number;
    title: string;
  }>;
};

export type W_Create = {
  company: string;
  versionNumber: string;
  platform: string | null;
};

export type W_Update_partial = Partial<{
  versionNumber: string;
  platform: string | null;
  changelog: string | null;
  releaseNotes: string | null;
  clientTestingStartedAt: string | null;
}>;

export type W_UpdateClient_partial = Partial<{
  releaseNotes: string | null;
}>;

export function useReadCollectionListCompanySub(
  companyId: string,
  queryParams?: {
    page?: number;
    platform?: string;
    'platform[]'?: Array<string>;
  },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V>>(
    `/companies/${companyId}/releases${makeQueryString(queryParams)}`,
    options
  );
}

export function useReadItemDetailCompanySub(
  companyId: string,
  versionNumber: string,
  options?: ReadConfig
) {
  return useApiRead<V>(
    `/companies/${companyId}/releases/${versionNumber}`,
    options
  );
}
